










import { Component, Vue, Prop } from 'vue-property-decorator'

import Booking from '@/models/booking'
import BookingStatusBarInterface, {
  BookingStatusBarTypes,
} from '@/models/booking-status-bar'

import { toCurrency } from '@/globalMixin'

@Component
export default class BookingStatusBar extends Vue {
  @Prop() booking!: Booking
  @Prop() showPreDepartureInfo!: boolean

  get statusBarPriority(): string {
    return this.bookingStatusBar?.priority || 'regular'
  }

  get statusBarComponent() {
    return { template: `<div> ${this.statusBarMessage} </div>` }
  }

  get bookingStatusBar(): BookingStatusBarInterface {
    return this.booking?.bookingStatusBar
  }

  get statusBarMessage(): string {
    if (!this.bookingStatusBar) {
      return ''
    }

    const {
      preDepartureInfoLink,
      booking,
      showPreDepartureInfo,
      bookingStatusBar: { type, data },
    } = this

    let amountFormatted

    switch (type) {
      case BookingStatusBarTypes.Cancelled:
        return '<strong>Your booking has been cancelled</strong>'
      case BookingStatusBarTypes.Expired:
        return 'Unfortunately your <strong>booking has expired</strong>'
      case BookingStatusBarTypes.SecureBookingFullPayment:
        return `Payment of <strong>${toCurrency(
          data.amountRequired,
          booking.currencyCode,
        )}</strong>
                is required to secure your booking! ${this.paymentLink()}`
      case BookingStatusBarTypes.SecureBookingDeposit:
        amountFormatted = toCurrency(data.amountRequired, booking.currencyCode)
        return `Deposit of
                <strong>
                  ${amountFormatted} ${
          data.paymentAllocationEnabled ? 'per person' : ''
        }
                </strong>
                is required to secure your booking! ${this.paymentLink()}`
      case BookingStatusBarTypes.FullPaymentOverdue:
        return `<strong>Full payment is overdue</strong>. ${this.paymentLink()}`
      case BookingStatusBarTypes.DepositOverdue:
        return `<strong>Deposit is overdue</strong>. ${this.paymentLink()}`
      case BookingStatusBarTypes.FullPaymentRequired:
        return `<strong>Full payment required</strong>. ${this.paymentLink()}`
      case BookingStatusBarTypes.DepositRequired:
        return `<strong>Deposit required</strong>. ${this.paymentLink()}`
      case BookingStatusBarTypes.MissingPassengerInfo:
        return 'Missing Information: Please ensure all passenger details are completed'
      case BookingStatusBarTypes.PredepartureInformationAvailable:
        if (!showPreDepartureInfo) {
          return ''
        }
        return `<strong>Pre-departure information available</strong>. ${preDepartureInfoLink}`
      case BookingStatusBarTypes.Confirmed:
        return '<strong>Booking Confirmed</strong>'
      default:
        return ''
    }
  }

  paymentLink(): string {
    return this.booking.paymentAllowed
      ? `
          <router-link
            :to="{
              name: 'makePayment',
              query: { bookingId: '${this.booking.id}' },
            }"
          >
            Pay now
          </router-link>
        `
      : ''
  }

  get preDepartureInfoLink(): string {
    return `<a href="${this.booking.direction.preDepartureInfo}"> View here </a>`
  }
}
